import React, { useEffect } from 'react';

export default function PrivacyPolicy() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://app.termly.io/embed-policy.min.js';
        script.id = 'termly-jssdk';
        document.body.appendChild(script);

        return () => {
            // The Termly SDK can relocate or remove its own script tag, so the
            // node may no longer be a child of document.body by unmount. Guard
            // the removal to avoid a NotFoundError when that happens.
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

    return (
        <div>
            <div
                name="termly-embed"
                data-id="91a84edd-2a37-4875-ad15-2bcf04ce4cea"
            />
        </div>
    );
}
